// extracted by mini-css-extract-plugin
export default {"shadow":"layout_shadow__1uXq7","content":"layout_content__1ILJU","border":"layout_border__lN8qp","wrapper":"layout_wrapper__CnhVo"};